'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bindings = exports.template = undefined;
exports.controller = controller;
exports.link = link;

var _thumbnail = require('project/thumbnail.scss');

var styles = _interopRequireWildcard(_thumbnail);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var template = exports.template = '\n<section class="' + styles.media + '">\n    <img class="' + styles.img + '" src="{{ctrl.project.img}}"/>\n</section>\n<section class="' + styles.info + '">\n    <div class="' + styles.line + '"></div>\n    <h3 class="' + styles.partner + '">{{ctrl.project.partner}}</h3>\n    <h1 class="' + styles.title + '">{{ctrl.project.title}}</h1>\n    <p class="' + styles.description + '">{{ctrl.project.description}}<p>\n    <div class="' + styles.bar + '"></div>\n</section>\n';

var bindings = exports.bindings = {
    project: '<'
};

function controller() {
    var ctrl = this;
}

function link($scope, $element, $attrs, ctrl) {}

var $directive = {
  scope: {},
  transclude: true
};

if(typeof bindings !== 'undefined') { $directive.bindToController = bindings }

angular.extend($directive, module.exports);

$directive.compile = function($element) {
  if(styles && styles.component) {
    $element.addClass(styles.component)
  }
  if(typeof(compile) === 'function') {
    return compile.apply(this, Array.prototype.slice.call(arguments));
  } else if(typeof(link) === 'function') {
    return {post: link};
  }
};

var $module = require('utils/module-registry').getModule('project');

if (controller) {
  $directive.controller = 'projectThumbnailCtrl as ctrl';
  $module.controller('projectThumbnailCtrl', controller);
}

$module.directive('projectThumbnail', function() { return $directive });


/*****************
 ** WEBPACK FOOTER
 ** ./project/thumbnail.directive.js
 ** module id = 29
 ** module chunks = 0
 **/